<script lang="ts">
	import { onMount } from 'svelte';
	import Map from '$lib/modules/Map.svelte';
	import type { OperationModel } from '../../../models/api/OperationModel';

	export let operation: OperationModel;

	let markers = [];

	onMount(async () => {
		let lat;
		let long;

		if (operation.address.latitude && operation.address.longitude) {
			lat = operation.address.latitude;
			long = operation.address.longitude;
		} else {
			const query = [
				operation.address.address,
				operation.address.cityCode,
				operation.address.city,
				operation.address.country
			].join(' ');

			try {
				const res = await fetch(encodeURI(`/places?search=${query}`));
				const data = await res.json();
				if (data?.length) {
					let position = data[0].position;
					lat = position?.lat;
					long = position?.lng;
				}
			} catch (e) {
				console.error(e);
			}
		}

		if (lat && long) {
			markers = [{ lat, long }];
		}
	});
</script>

{#if markers?.length}
	<Map initialPointOfView={[47.210978, 2.712891]} {markers} />
{/if}
